import { LoadIndicator } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import TagBox from 'devextreme-react/tag-box';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, CardBody, CardFooter, Col, Row } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import apii from '../../../services/api-configuration-v3.js';
import { getAllWarehouses } from '../../../services/apis';

// Kolon konfigürasyonları
const COLUMN_CONFIGS = {
    //	NOT	PDIBlokaj	ParkBolge	PDIGirisTarih
    saseList: [
        { field: 'sasi', header: 'ŞASİ NUMARASI' },
        { field: 'marka', header: 'MARKA' },
        { field: 'model', header: 'MODEL' },
        { field: 'versiyon', header: 'MODEL VERSİYON' },
        { field: 'fatura_durum', header: 'FATURA DURUM' },
        { field: 'fatura_tarihi', header: 'FATURA TARİHİ' },
        { field: 'fatura_bayi', header: 'FATURA BAYİ' },
        { field: 'fatura_ili', header: 'FATURA İLİ' },
        { field: 'fatura_bayi_kodu', header: 'FATURA BAYİ KODU' }, //TODO
        { field: 'sevk_degisikligi_talebi', header: 'SEVK DEĞİŞİKLİĞİ TALEBİ' },
        { field: 'sevk_bayi', header: 'SEVK BAYİ' },
        { field: 'sevk_ili', header: 'SEVK İL' },

        { field: 'blokaj_sevk_durum', header: 'BLOKAJ/SEVK DURUMU' },
        { field: 'blokaj_talep_tarihi', header: 'BLOKAJ TALEP TARİHİ' },
        { field: 'blokaj_kaldirma_tarihi', header: 'BLOKAJ KALDIRMA TARİHİ' },
        { field: 'pdi_durumu', header: 'PDI DURUMU' },
        { field: 'pdi_tarihi', header: 'PDI TARİHİ' },
        { field: 'yazilim_durumu', header: 'YAZILIM DURUMU' },
        { field: 'yazilim_tarihi', header: 'YAZILIM TARİHİ' },
        { field: 'tamir_durumu', header: 'TAMİR DURUMU' },
        { field: 'tamir_tarihi', header: 'TAMİR TARİHİ' },
        { field: 'parca_durumu', header: 'PARÇA DURUMU' },
        { field: 'ithalat_durumu', header: 'İTHALAT DURUMU' },
        { field: 'sevke_hazir_tarihi', header: 'SEVK HAZIR HALE GELME TARİHİ' },
        { field: 'sevk_tarihi', header: 'SEVK TARİHİ' },
        { field: 'liman_antrepo', header: 'LİMAN/ANTREPO' },
        { field: 'arac_statusu', header: 'ARAÇ STATÜSÜ' },
        { field: 'teslim_tarihi', header: 'TESLİM TARİHİ' },
        { field: 'nakliyeci', header: 'NAKLİYECİ' },
        { field: 'not', header: 'NOT' },
        { field: 'gemi_varis_tarihi', header: 'GEMİ VARIŞ TARİHİ' },
        { field: 'ithalat_tarihi', header: 'İTHALAT TARİHİ' },
        { field: 'kanal_tipi', header: "KANAL TİPİ" },
        { field: 'pdi_blokaj', header: 'PDIBlokaj' },
        { field: 'park_bolgesi', header: 'ParkBolge' },
        { field: 'pdi_giris_tarihi', header: 'PDIGirisTarih' },
        { field: 'grupaj_no', header: 'GrupajNo' },
        { field: 'priority_level', header: 'OncelikNo' }, // TODO
        { field: 'acik_pdi_emri', header: 'AcikPDIEmri' },
        { field: 'acik_dptr_emri', header: 'AcikDPTREmri' },
        { field: 'pdi_statu', header: 'PDIStatu' }

    ],
    stellantisReport: [
        // NO	ŞASE NUMARASI	MARKA	MODEL	BAYİ	İL	SEVK TARİHİ	FATURA TARİHİ	PDI TARİHİ	SAHA
        { field: 'sira_numarasi', header: 'No' },
        { field: 'sasi', header: 'Şase Numarası' },
        { field: 'marka', header: 'Marka' },
        { field: 'model', header: 'Model' },
        { field: 'bayi', header: 'Bayi' },
        { field: 'il', header: 'İl' },
        { field: 'sevk_tarihi', header: 'Sevk Tarihi' },
        { field: 'fatura_tarihi', header: 'Fatura Tarihi' },
        { field: 'pdi_tarihi', header: 'PDI Tarihi' },
        { field: 'saha', header: 'Saha' }
    ],
    sevkvestok: [
        // ŞASİ NUMARASI	MARKA	MODEL	MODEL VERSİYON	FATURA DURUM	FATURA TARİHİ	FATURA BAYİ	FATURA İLİ	FATURA BAYİ KODU	SEVK DEĞİŞİKLİĞİ TALEBİ	SEVK BAYİ	SEVK İL	BLOKAJ/SEVK DURUMU	BLOKAJ TALEP TARİHİ	BLOKAJ KALDIRMA TARİHİ	PDI DURUMU	PDI TARİHİ	YAZILIM DURUMU	YAZILIM TARİHİ	TAMİR DURUMU	TAMİR TARİHİ	PARÇA DURUMU	İTHALAT DURUMU	SEVK HAZIR HALE GELME TARİHİ	SEVK TARİHİ	LİMAN/ANTREPO	ARAÇ STATÜSÜ	TESLİM TARİHİ	NAKLİYECİ	NOT	PDIBlokaj	ParkBolge	PDIGirisTarih
        { field: 'sasi', header: 'ŞASİ NUMARASI' },
        { field: 'marka', header: 'MARKA' },
        { field: 'model', header: 'MODEL' },
        { field: 'versiyon', header: 'MODEL VERSİYON' },
        { field: 'fatura_durum', header: 'FATURA DURUM' },
        { field: 'fatura_tarihi', header: 'FATURA TARİHİ' },
        { field: 'fatura_bayi', header: 'FATURA BAYİ' },
        { field: 'fatura_ili', header: 'FATURA İLİ' },
        { field: 'fatura_bayi_kodu', header: 'FATURA BAYİ KODU' }, //TODO
        { field: 'sevk_degisikligi_talebi', header: 'SEVK DEĞİŞİKLİĞİ TALEBİ' },
        { field: 'sevk_bayi', header: 'SEVK BAYİ' },
        { field: 'sevk_ili', header: 'SEVK İL' },

        { field: 'blokaj_sevk_durum', header: 'BLOKAJ/SEVK DURUMU' },
        { field: 'blokaj_talep_tarihi', header: 'BLOKAJ TALEP TARİHİ' },
        { field: 'blokaj_kaldirma_tarihi', header: 'BLOKAJ KALDIRMA TARİHİ' },
        { field: 'pdi_durumu', header: 'PDI DURUMU' },
        { field: 'pdi_tarihi', header: 'PDI TARİHİ' },
        { field: 'yazilim_durumu', header: 'YAZILIM DURUMU' },
        { field: 'yazilim_tarihi', header: 'YAZILIM TARİHİ' },
        { field: 'tamir_durumu', header: 'TAMİR DURUMU' },
        { field: 'tamir_tarihi', header: 'TAMİR TARİHİ' },
        { field: 'parca_durumu', header: 'PARÇA DURUMU' },
        { field: 'ithalat_durumu', header: 'İTHALAT DURUMU' },
        { field: 'sevke_hazir_tarihi', header: 'SEVK HAZIR HALE GELME TARİHİ' },
        { field: 'sevk_tarihi', header: 'SEVK TARİHİ' },
        { field: 'liman_antrepo', header: 'LİMAN/ANTREPO' },
        { field: 'arac_statusu', header: 'ARAÇ STATÜSÜ' },
        { field: 'teslim_tarihi', header: 'TESLİM TARİHİ' },
        { field: 'nakliyeci', header: 'NAKLİYECİ' },
        { field: 'not', header: 'NOT' },
        { field: 'gemi_varis_tarihi', header: 'GEMİ VARIŞ TARİHİ' },
        { field: 'ithalat_tarihi', header: 'İTHALAT TARİHİ' },
        { field: 'kanal_tipi', header: "KANAL TİPİ" },
        { field: 'pdi_blokaj', header: 'PDIBlokaj' },
        { field: 'park_bolgesi', header: 'ParkBolge' },
        { field: 'pdi_giris_tarihi', header: 'PDIGirisTarih' },
        { field: 'grupaj_no', header: 'GrupajNo' },
        { field: 'priority_level', header: 'OncelikNo' }, //TODO
        { field: 'acik_pdi_emri', header: 'AcikPDIEmri' },
        { field: 'acik_dptr_emri', header: 'AcikDPTREmri' },
        { field: 'pdi_statu', header: 'PDIStatu' }
    ]
};

const GuncelDurum = () => {
    const [dateRange, setDateRange] = useState([new Date(), new Date()]);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const [visibleLoader, setVisibleLoader] = useState({
        saseList: null,
        stellantisReport: null,
        sevkvestok: null
    });
    const [warehouses, setWarehouses] = useState([]);
    const [reportData, setReportData] = useState({});
    const [excelFiles, setExcelFiles] = useState({});
    const [downloadingFiles, setDownloadingFiles] = useState({});
    const [stats, setStats] = useState({
        saseList: null,
        stellantisReport: null,
        sevkvestok: null
    });

    const REPORT_KEY = {
        saseList: 7,
        stellantisReport: 1,
        sevkvestok: 10
    };

    useEffect(() => {
        const fetchWarehouses = async () => {
            try {
                const response = await getAllWarehouses();
                if (Array.isArray(response)) {
                    await response.push(
                        {
                            "address": "75. YIL  MAHALLESİ, ÇEVREYOLU BULVARI, NO:2, ODUNPAZARI",
                            "address_description": "TIR için oluşturulmuş sanal alan",
                            "address_id": 82,
                            "capacity": 100000,
                            "create_date": "2024-12-17 21:43:40",
                            "create_user_id": 3118582,
                            "discharge_area_status": false,
                            "id": 28,
                            "is_active": true,
                            "tax_number": "TIR",
                            "tax_office": "TIR",
                            "warehouse_code": "D000007",
                            "warehouse_description": "TIR",
                            "warehouse_name": "TIR",
                            "warehouse_short_name": "TIR"
                        }
                    );
                }
                setWarehouses(response);
            } catch (error) {
                console.error('Error fetching warehouses:', error);
            }
        };

        fetchWarehouses();
    }, []);

    const handleDateChange = (e) => setDateRange(e.value);
    const handleWarehouseChange = (e) => setSelectedWarehouse(e.value);

    const fetchReport = async (reportKey, id) => {
        if (id === null) {
            setStats(prev => ({
                ...prev,
                [reportKey]: null
            }));
            setVisibleLoader(prev => ({
                ...prev,
                [reportKey]: false
            }));
            return;
        }

        try {
            // Tüm raporlar için yeni API kullan
            const response = await apii.post('/reports/getExcelReport', {
                startDate: (id === 10) ? `${new Date().getFullYear()}-01-01` :
                    id === 1 ? null : "1000-01-01",
                endDate: id === 1 ? null : "9999-12-31",
                warehouseIDs: (!selectedWarehouse || selectedWarehouse?.length === 0) ? warehouses.map(w => w.id) : selectedWarehouse,
                reportID: id,
                columnOrder: COLUMN_CONFIGS[reportKey].map(col => col.header)
            }, {
                responseType: 'blob',
                headers: {
                    'Accept': 'application/octet-stream',
                    'Content-Type': 'application/json'
                }
            });

            // Excel dosyasını tut
            const blob = new Blob([response.data]);
            setExcelFiles(prev => ({
                ...prev,
                [reportKey]: blob
            }));

            // Row count'u al ve stats'e kaydet
            const rowCount = response.headers['x-row-count'];
            const count = rowCount ? parseInt(rowCount) : 0;

            setStats(prev => ({
                ...prev,
                [reportKey]: count
            }));

        } catch (error) {
            // Yeni hata yönetimi
            const errorMessage = error.response?.data?.error || error.message || '';
            console.error(errorMessage);
            if (errorMessage.includes('empty data') || errorMessage.includes('failed to generate Excel')) {
                setStats(prev => ({
                    ...prev,
                    [reportKey]: 0
                }));
                setExcelFiles(prev => {
                    const newState = { ...prev };
                    delete newState[reportKey];
                    return newState;
                });
            } else {
                setStats(prev => ({
                    ...prev,
                    [reportKey]: 'Hata'
                }));
                setExcelFiles(prev => {
                    const newState = { ...prev };
                    delete newState[reportKey];
                    return newState;
                });
                let message = error.response?.data?.error || 'Beklenmedik bir hata oluştu';
                toast.error(message + ` (${reportKey})`);
            }
        } finally {
            setVisibleLoader(prev => ({
                ...prev,
                [reportKey]: false
            }));
        }
    };

    const handleListele = async () => {
        if (!dateRange[0] || !dateRange[1]) {
            toast.error("Lütfen bir tarih aralığı seçiniz.");
            return;
        }

        // If no warehouse is selected, use all warehouse IDs
        const warehouseIdsToUse = selectedWarehouse?.length ? selectedWarehouse :
            warehouses.map(warehouse => warehouse.id);

        setStats(prev => Object.keys(prev).reduce((acc, key) => ({
            ...acc,
            [key]: REPORT_KEY[key] === null ? null : 0
        }), {}));

        const initialLoaders = Object.keys(visibleLoader).reduce((acc, key) => ({
            ...acc,
            [key]: REPORT_KEY[key] !== null
        }), {});
        setVisibleLoader(initialLoaders);

        // Update fetchReport function to use warehouseIdsToUse
        const fetchReportWithWarehouses = async (reportKey, id) => {
            if (id === null) {
                setStats(prev => ({
                    ...prev,
                    [reportKey]: null
                }));
                setVisibleLoader(prev => ({
                    ...prev,
                    [reportKey]: false
                }));
                return;
            }

            try {
                // Tüm raporlar için yeni API kullan
                const response = await apii.post('/reports/getExcelReport', {
                    startDate: (id === 10) ? `${new Date().getFullYear()}-01-01` :
                        id === 1 ? null : "1000-01-01",
                    endDate: id === 1 ? null : "9999-12-31",
                    warehouseIDs: warehouseIdsToUse,
                    reportID: id,
                    columnOrder: COLUMN_CONFIGS[reportKey].map(col => col.header)
                }, {
                    responseType: 'blob',
                    headers: {
                        'Accept': 'application/octet-stream',
                        'Content-Type': 'application/json'
                    }
                });

                // Excel dosyasını tut
                const blob = new Blob([response.data]);
                setExcelFiles(prev => ({
                    ...prev,
                    [reportKey]: blob
                }));

                // Row count'u al ve stats'e kaydet
                const rowCount = response.headers['x-row-count'];
                const count = rowCount ? parseInt(rowCount) : 0;

                setStats(prev => ({
                    ...prev,
                    [reportKey]: count
                }));

            } catch (error) {
                // Yeni hata yönetimi
                const errorMessage = error.response?.data?.error || error.message || '';
                console.error(errorMessage);
                if (errorMessage.includes('empty data') || errorMessage.includes('failed to generate Excel')) {
                    setStats(prev => ({
                        ...prev,
                        [reportKey]: 0
                    }));
                    setExcelFiles(prev => {
                        const newState = { ...prev };
                        delete newState[reportKey];
                        return newState;
                    });
                } else {
                    setStats(prev => ({
                        ...prev,
                        [reportKey]: 'Hata'
                    }));
                    setExcelFiles(prev => {
                        const newState = { ...prev };
                        delete newState[reportKey];
                        return newState;
                    });
                    let message = error.response?.data?.error || 'Beklenmedik bir hata oluştu';
                    toast.error(message + ` (${reportKey})`);
                }
            } finally {
                setVisibleLoader(prev => ({
                    ...prev,
                    [reportKey]: false
                }));
            }
        };

        const reportPromises = Object.entries(REPORT_KEY).map(([key, id]) =>
            fetchReportWithWarehouses(key, id)
        );

        await Promise.allSettled(reportPromises);
    };


    const downloadExcel = async (reportKey, excel_name) => {
        try {
            const rowCount = stats[reportKey];

            // Row count 0 ise indirme yapma
            if (rowCount === 0) {
                toast.warning(`${excel_name} için indirilebilir veri bulunmuyor`);
                return;
            }

            const excelFile = excelFiles[reportKey];

            if (!excelFile) {
                toast.error('Excel dosyası bulunamadı. Lütfen önce "Listele" butonuna basın.');
                return;
            }

            // İndirme başladığını belirt
            setDownloadingFiles(prev => ({
                ...prev,
                [reportKey]: true
            }));

            // Kısa bir gecikme ekle (kullanıcı deneyimi için)
            await new Promise(resolve => setTimeout(resolve, 500));

            // Dosyayı indir
            const url = window.URL.createObjectURL(excelFile);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${excel_name}_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (error) {
            console.error('Excel indirme hatası:', error);
            toast.error('Excel dosyası indirilirken hata oluştu');
        } finally {
            // İndirme durumunu sıfırla
            setDownloadingFiles(prev => ({
                ...prev,
                [reportKey]: false
            }));
        }
    };


    const StatsCard = ({ title, value, color, keyA, excel_name }) => (
        <Card className="mb-4" style={{
            background: `linear-gradient(135deg, ${color}25, ${color}40)`,
            border: 'none',
            boxShadow: `0 4px 6px ${color}15`,
            transition: 'transform 0.2s, box-shadow 0.2s',
            ':hover': {
                transform: 'translateY(-5px)',
                boxShadow: `0 6px 8px ${color}25`
            }
        }}>
            <CardBody className="text-center position-relative" style={{
                borderLeft: `4px solid ${color}`,
                padding: '1.5rem'
            }}>
                <>
                    <h2 className="mb-3" style={{
                        fontSize: '2.5rem',
                        fontWeight: '700',
                        fontFamily: 'Roboto Mono, monospace',
                        color: '#1a202c',
                        position: 'relative',
                        zIndex: 1
                    }}>
                        {
                            visibleLoader[keyA] ? <LoadIndicator width="40px" height="40px" /> : value === 'Hata' ? 'Hata' : value === null ? "-" : value
                        }
                    </h2>
                    <p style={{
                        fontSize: '1rem',
                        fontWeight: '600',
                        letterSpacing: '0.025em',
                        color: '#2d3748',
                        marginBottom: 0
                    }}>
                        {
                            visibleLoader[keyA] ? 'Yükleniyor...' : title?.toLocaleUpperCase('tr-TR')
                        }
                    </p>
                </>
            </CardBody>
            <CardFooter
                onClick={() => (value !== null && value !== 'Hata' && value !== 0) ? downloadExcel(keyA, excel_name) : null}
                style={{
                    background: `${color}30`,
                    borderTop: `1px solid ${color}50`,
                    padding: '0.75rem',
                    cursor: (value !== null && value !== 'Hata' && value !== 0) ? 'pointer' : 'not-allowed',
                    opacity: (value !== null && value !== 'Hata' && value !== 0) ? 1 : 0.5,
                    transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                    if (value !== null && value !== 'Hata' && value !== 0) {
                        e.currentTarget.style.background = `${color}50`;
                    }
                }}
                onMouseLeave={(e) => {
                    if (value !== null && value !== 'Hata' && value !== 0) {
                        e.currentTarget.style.background = `${color}30`;
                    }
                }}
            >
                <div className="text-center">
                    {downloadingFiles[keyA] ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <LoadIndicator width="16px" height="16px" />
                            <span style={{
                                fontSize: '0.875rem',
                                color: '#2d3748',
                                fontWeight: '600'
                            }}>
                                İndiriliyor...
                            </span>
                        </div>
                    ) : (
                        <span style={{
                            fontSize: '0.875rem',
                            color: '#2d3748',
                            fontWeight: '600'
                        }}>
                            Excele İndir &nbsp; <i className="fa fa-download"></i>
                        </span>
                    )}
                </div>
            </CardFooter>
        </Card>
    );

    return (
        <>
            <Breadcrumb current="Anlık Raporlar" />
            <div className="p-4" style={{ background: '#f8fafc' }}>
                <Card className="mb-6" style={{
                    background: 'white',
                    border: 'none'
                }}>
                    <CardBody className="">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-4">
                            <div style={{ minWidth: '250px' }}>
                                {/* <DateRangeBox
                                    value={dateRange}
                                    onValueChanged={handleDateChange}
                                    showClearButton={true}
                                    placeholder="Rapor Tarih Aralığı"
                                /> */}
                            </div>
                            <div className="d-flex align-items-center justify-content-end" style={{ flex: 1, gap: "5px" }}>
                                <div style={{ flex: 1, maxWidth: '400px' }}>
                                    <TagBox
                                        dataSource={warehouses}
                                        displayExpr="warehouse_name"
                                        valueExpr="id"
                                        placeholder="Depo Seçiniz"
                                        value={selectedWarehouse}
                                        onValueChanged={handleWarehouseChange}
                                    />
                                </div>
                                <div>
                                    <Button
                                        type="default"
                                        onClick={handleListele}
                                        color="success"
                                        style={{
                                            color: 'white',
                                            height: '40px',
                                            border: 'none',
                                            fontWeight: '500',
                                            transition: 'all 0.3s'
                                        }}
                                    >
                                        <i className="fa fa-list m-0" /> &nbsp;
                                        Listele
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>

                <div className="p-4 card">
                    <Row>
                        <Col md={3}>
                            <StatsCard
                                keyA="saseList"
                                excel_name="Stok Raporu"
                                title="Stok Raporu"
                                value={stats.saseList}
                                color="#f59e0b"
                            />
                        </Col>

                        <Col md={3}>
                            <StatsCard
                                keyA="stellantisReport"
                                excel_name="Sevk Raporu"
                                title="Sevk Raporu"
                                value={stats.stellantisReport}
                                color="#ef4444"
                            />
                        </Col>

                        <Col md={3}>
                            <StatsCard
                                keyA="sevkvestok"
                                excel_name="Stok ve Sevk Raporu"
                                title="Stok + Sevk Raporu"
                                value={stats.sevkvestok}
                                color="#3b82f6"
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default GuncelDurum;